import React, { Component } from "react"
import Icon from "../elements/Icon"
import { throttle } from "lodash/function"
import classnames from "classnames"
import { getXHR } from "../../scripts/XHR.js"
//import Wavesurfer from 'react-wavesurfer'; // Can't include here as this is not isomorphic friendly
import {
  getStyles,
  getStyleTag,
  hexToRgbA,
  getLightenColor
} from "../../styles/dynamicStyles"
import { getAccountSettings } from "../../scripts/accountSettings"
import { injectIntl } from "react-intl"
import settingsMessages from "../../messages/settings"

class AudioPlayer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      playing: false,
      pos: 0,
      volume: 0.5,
      duration: 0,
      instance: null,
      canUseDom: false,
      ready: false
    }

    this._barsHeight = (this.props.smallForm && 160) || 300

    // Will set these on componentDidMount
    this._progressGrad = null
    this._waveGrad = null
    this._ReactWavesurfer = null // Will be set to react-wavesurfer component
    this._wavesurfer = null // Will be set to wavesufer dom instance
  }

  componentDidMount() {
    const {
      settings: {
        colours,
        style: { content: contentType }
      }
    } = getAccountSettings(
      this.props.intl.formatMessage(settingsMessages.authenticAccountId)
    )

    this._ReactWavesurfer = require("react-wavesurfer").default

    this._devicePixelRatio = this._getDevicePixelRatio() //wavesurfer drawers the canvas large for higher pixelratios, so we also need to factor this in when we create our gradients below

    const isDefault = contentType === "default"

    //bar gradients
    this._progressGrad = document
      .createElement("canvas")
      .getContext("2d")
      .createLinearGradient(0, 0, 0, this._barsHeight * this._devicePixelRatio)
    this._progressGrad.addColorStop(
      0,
      isDefault ? "#D8E7F0" : colours.secondary
    )
    this._progressGrad.addColorStop(0.5, "#ffffff")
    this._progressGrad.addColorStop(0.501, "rgba(255,255,255,0)")
    this._progressGrad.addColorStop(1, "rgba(255,255,255,0)")

    this._waveGrad = document
      .createElement("canvas")
      .getContext("2d")
      .createLinearGradient(0, 0, 0, this._barsHeight * this._devicePixelRatio)
    this._waveGrad.addColorStop(
      0,
      isDefault ? "rgba(52,124,145,0.15)" : hexToRgbA(colours.primary, 0.15)
    )
    this._waveGrad.addColorStop(
      0.12,
      isDefault ? "rgba(68,133,151,0.35)" : hexToRgbA(colours.primary, 0.35)
    )
    this._waveGrad.addColorStop(
      0.5,
      isDefault ? "#72A0AB" : getLightenColor(colours.primary, 0.9)
    )
    this._waveGrad.addColorStop(0.501, isDefault ? "#115D70" : colours.primary)
    this._waveGrad.addColorStop(1, "rgba(6,48,59,0)")

    if (this.props.peaksURL) {
      getXHR(this.props.peaksURL)
        .then(res => {
          const peaks = JSON.parse(res).data.map(p => Math.abs(p))

          this.setState({
            peaks: peaks,
            canUseDOM: true
          })
        })
        .catch(() => {
          //Couldn't get peaks
          this.setState({
            canUseDOM: true
          })
        })
    } else {
      this.setState({
        canUseDOM: true
      })
    }
  }

  _getDevicePixelRatio = () => {
    let pixelRatio = 1 // just for safety

    if ("deviceXDPI" in screen) {
      // IE mobile or IE
      pixelRatio = screen.deviceXDPI / screen.logicalXDPI
    } else if (window.hasOwnProperty("devicePixelRatio")) {
      // other devices
      pixelRatio = window.devicePixelRatio
    }

    return pixelRatio
  }

  _handleTogglePlay = evt => {
    evt.preventDefault()
    this.setState({
      playing: !this.state.playing
    })
  }

  _handlePosChange = evt => {
    this.setState({
      pos: evt.originalArgs ? evt.originalArgs[0] : +evt.target.value
    })
  }

  _handleReady = args => {
    this._wavesurfer = args.wavesurfer

    window.addEventListener("resize", throttle(this._resizeWaveform, 200))

    // call method immediately:
    this.duration = this._wavesurfer.getDuration()

    //determine good skip length
    this.skipLength = this.duration / 20

    //round to nearest 10
    this.skipLength = Math.round(this.skipLength / 10) * 10
    if (this.skipLength < 10) {
      this.skipLength = 10
    }
    if (this.skipLength > 60) {
      this.skipLength = 60
    }

    // if(this.skiplength)

    this.setState({
      duration: this.duration,
      ready: true
    })
  }

  _resizeWaveform = () => {
    if (this.state.ready) {
      this._wavesurfer.drawer.containerWidth = this._wavesurfer.drawer.container.clientWidth
      this._wavesurfer.drawBuffer()
    }
  }

  // _handleLoading = (args) => {
  //     this.lduration = args.wavesurfer.getDuration();
  //     this.lskipLength = this.lduration / 25;

  //     this.setState({
  //         playing: !this.state.playing
  //     });
  // };

  // _handleAudioprocess = (args) => {
  //     this.aduration = args.wavesurfer.getDuration();
  //     this.askipLength = this.aduration / 25;

  //     this.setState({
  //         playing: !this.state.playing
  //     });
  // };

  _handleFinish = () => {
    this.setState({
      playing: false,
      pos: 0
    })
  }

  _handleSkipBackward = evt => {
    evt.preventDefault()
    this.setState({
      // needs to be slightly greter than 0 inorder to keep playing properly
      pos:
        this.state.pos - this.skipLength > 0
          ? this.state.pos - this.skipLength
          : 0.00001
    })
  }

  _handleSkipForward = evt => {
    evt.preventDefault()
    if (this.state.pos + this.skipLength < this.duration) {
      this.setState({
        pos: this.state.pos + this.skipLength
      })
    } else {
      //send to end (has to be slightly before to properly trigger end event)
      this.setState({
        pos: this.duration - 0.0000001
      })
    }
  }

  _handleVolumeChange = e => {
    this.setState({
      volume: +e.target.value
    })
  }

  _timeFormat = input => {
    if (!input) {
      return "00:00"
    }

    var minutes = Math.floor(input / 60)
    var seconds = Math.ceil(input) % 60

    return (
      (minutes < 10 ? "0" : "") +
      minutes +
      ":" +
      (seconds < 10 ? "0" : "") +
      seconds
    )
  }

  render() {
    const Wavesurfer = this.state.canUseDOM && this._ReactWavesurfer

    const Wave = Wavesurfer ? (
      // Dom ready, client side
      <Wavesurfer
        audioFile={this.props.src}
        audioPeaks={this.state.peaks}
        volume={this.state.volume}
        pos={this.state.pos}
        options={{
          height: this._barsHeight,
          backend: "MediaElement",
          progressColor: this._progressGrad, //'#D8E7F0',
          waveColor: this._waveGrad, //'#ffffff',
          normalize: true,
          barWidth: 2
        }}
        onPosChange={this._handlePosChange}
        playing={this.state.playing}
        onReady={this._handleReady}
        onFinish={this._handleFinish}
        // onAudioprocess={this._handleAudioprocess}
        // onLoading={this._handleLoading}
      />
    ) : (
      // No Dom, server side
      <div>{this.props.children}</div>
    )

    return (
      <div
        className={classnames("c-mviewer__audio wavesurfer", {
          "c-mviewer__audio--smallform": this.props.smallForm,
          "wavesurfer--smallform": this.props.smallForm
        })}
        data-is-playing={this.state.playing}
        data-is-ready={this.state.ready}
      >
        {Wave}
        {getStyleTag("wavesurfer__control--play-pause")}
        <div className="wavesurfer__controls">
          <button
            onClick={this._handleSkipBackward}
            className="wavesurfer__control wavesurfer__control--skip wavesurfer__control--skip-previous button"
            style={getStyles("wavesurfer__control--skip")}
          >
            <Icon icon="turn-backwards" />
            <span>{this.skipLength}</span>
          </button>
          <button
            onClick={this._handleTogglePlay}
            className="button wavesurfer__control wavesurfer__control--play-pause"
            style={getStyles("wavesurfer__control--play-pause")}
          >
            <Icon icon="custom" extraClasses="control--play-pause" />
          </button>
          <button
            onClick={this._handleSkipForward}
            className="wavesurfer__control wavesurfer__control--skip wavesurfer__control--skip-next button"
            style={getStyles("wavesurfer__control--skip")}
          >
            <Icon icon="turn-forwards" />
            <span>{this.skipLength}</span>
          </button>
          {/*<br/>
          <input type="range"
            min={0}
            max={1}
            step="0.01"
            value={this.state.volume}
            onChange={this._handleVolumeChange}
            className="form-control"
          />*/}
          <span className="wavesurfer__time">
            {this._timeFormat(this.state.pos)} <em>of</em>{" "}
            {this._timeFormat(this.state.duration)}
          </span>
        </div>
      </div>
    )
  }
}

export default injectIntl(AudioPlayer)



// WEBPACK FOOTER //
// ./webapp/components/elements/AudioPlayer.js